import { Box, Container, Paper, Typography } from "@mui/material";
import { FC, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "../../store";
import User from "../../types/user";
import Button from "../base/Button";
import AddEditUser, { UserFormSubmitHandler } from "./AddEditUser";
import { editUser } from "../../slices/user";
import Companies from "./Companies";
import { useNavigate } from "react-router-dom";
import CompanyLogo from "../base/CompanyLogo";
import { getPasskeys, checkMfaEnabled } from "../../slices/auth";

const Account: FC = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { status, dbUser } = useSelector((store) => store.auth);
  const { selectedCompany, allowedCompanies } = useSelector(
    (store) => store.company
  );
  const { ssoStatus } = useSelector((store) => store.provider);

  const formSubmitHandlerRef = useRef<UserFormSubmitHandler | null>(null);

  const handleSave = async (data: User) => {
    dispatch(editUser(data));
  };

  const handleSelectCompany = () => {
    navigate("/account");
  };

  // useEffect(() => {
  //   dispatch(getPasskeys());
  // }, [dispatch]);

  // useEffect(() => {
  //   dispatch(checkMfaEnabled());
  // }, [dispatch]);

  return (
    <Container sx={{ marginBottom: 8 }}>
      {!!selectedCompany?.finishedSetup ? (
        <Paper
          sx={{
            paddingY: 3,
            paddingX: { xs: 2, md: 5 },
            marginBottom: 3,
          }}
        >
          {selectedCompany && (
            <Box
              display="flex"
              flexDirection="column"
              width="100%"
              justifyContent="center"
              alignItems="center"
            >
              {selectedCompany?.finishedSetup && (
                <Box
                  display="flex"
                  flexDirection="row"
                  width="100%"
                  justifyContent="center"
                  alignItems="center"
                  padding={1}
                  gap={3}
                  marginBottom={3}
                >
                  <CompanyLogo company={selectedCompany} size="70px" />
                  <Typography variant="h5">
                    {`Update user information for ${
                      selectedCompany?.settings?.companyName
                    }. ${
                      allowedCompanies?.length > 1 && !ssoStatus?.useSso
                        ? `Any information changed
              here is specific to this company and will not affect your user
              profile for other companies.`
                        : ""
                    }`}
                  </Typography>
                </Box>
              )}

              <AddEditUser
                user={dbUser}
                type="profile"
                onSubmit={handleSave}
                ref={formSubmitHandlerRef}
              />
              <Box
                display="flex"
                flexDirection="row"
                width="100%"
                justifyContent="flex-end"
                gap={2}
                mt={2}
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                >
                  <Button
                    label="Save"
                    variant={"contained"}
                    color={"primary"}
                    onClick={() => formSubmitHandlerRef.current?.()}
                    disabled={status === "loading"}
                  />
                </Box>
              </Box>
            </Box>
          )}
        </Paper>
      ) : (
        !selectedCompany &&
        allowedCompanies.length > 0 &&
        !ssoStatus?.useSso && (
          <>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignContent="center"
              justifyItems="center"
              alignItems="center"
              paddingX={30}
              paddingBottom={5}
            >
              <Typography variant="h4" textAlign="center">
                You have access to the following companies. Select one below to
                update your account information for the company.
              </Typography>
            </Box>
            <Companies handleSelect={handleSelectCompany} />
          </>
        )
      )}
      {/* {authMethod !== "sso" && (
        <Box display="flex" flexDirection={"column"} width={"100%"} gap={3}>
          <Box
            display="flex"
            flexDirection={"row"}
            width={"100%"}
            justifyContent={"center"}
          >
            <Typography variant="h4">
              Secure your account by using a passkey or setting up MFA.
            </Typography>
          </Box>
          <MfaSetupView />
        </Box>
      )} */}
    </Container>
  );
};

export default Account;
